import React, { FunctionComponent } from 'react'
import { FormError, FormInput, FormLabel, InputProps } from '../Form'

export const FileInput: FunctionComponent<InputProps> = props => {
  const { fieldName, label, register, registerOptions, errors, disabled } = props
  return (
    <>
      <FormLabel>{label}</FormLabel>
      <FormInput
        type='file'
        accept='.pdf,image/*'
        disabled={disabled}
        ref={register}
        {...register(fieldName, registerOptions)}
      />
      {errors && <FormError>{errors.message}</FormError>}
    </>
  )
}
